var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('group-login-register',{attrs:{"open":true},on:{"isLogin":_vm.isLogin,"switchLoginType":_vm.switchLoginType}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }